import React, { useContext } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var CaravaggioContext = React.createContext(null);
var CaravaggioProvider = function (_a) {
    var children = _a.children, url = _a.url, baseUrl = _a.baseUrl;
    return (React.createElement(CaravaggioContext.Provider, { value: { url: url, baseUrl: baseUrl } }, children));
};

// This hook expose the Caravaggio url through the context
var useCaravaggio = function () {
    var context = useContext(CaravaggioContext);
    if (!context) {
        throw new Error('The "useCaravaggio" hook can be called only as descendant of CaravaggioProvider');
    }
    return context;
};

var GRAVITY;
(function (GRAVITY) {
    GRAVITY["c"] = "center";
    GRAVITY["n"] = "north";
    GRAVITY["ne"] = "northeast";
    GRAVITY["nw"] = "northwest";
    GRAVITY["e"] = "east";
    GRAVITY["w"] = "west";
    GRAVITY["s"] = "south";
    GRAVITY["se"] = "southeast";
    GRAVITY["sw"] = "southwest";
    GRAVITY["center"] = "center";
    GRAVITY["centre"] = "centre";
    GRAVITY["north"] = "north";
    GRAVITY["northeast"] = "northeast";
    GRAVITY["northwest"] = "northwest";
    GRAVITY["east"] = "east";
    GRAVITY["west"] = "west";
    GRAVITY["south"] = "south";
    GRAVITY["southeast"] = "southeast";
    GRAVITY["southwest"] = "southwest";
    GRAVITY["auto"] = "attention";
    // With g-prefix
    GRAVITY["gc"] = "center";
    GRAVITY["gn"] = "north";
    GRAVITY["gne"] = "northeast";
    GRAVITY["gnw"] = "northwest";
    GRAVITY["ge"] = "east";
    GRAVITY["gw"] = "west";
    GRAVITY["gs"] = "south";
    GRAVITY["gse"] = "southeast";
    GRAVITY["gsw"] = "southwest";
    GRAVITY["gcenter"] = "center";
    GRAVITY["gcentre"] = "centre";
    GRAVITY["gnorth"] = "north";
    GRAVITY["gnortheast"] = "northeast";
    GRAVITY["gnorthwest"] = "northwest";
    GRAVITY["geast"] = "east";
    GRAVITY["gwest"] = "west";
    GRAVITY["gsouth"] = "south";
    GRAVITY["gsoutheast"] = "southeast";
    GRAVITY["gsouthwest"] = "southwest";
    GRAVITY["gauto"] = "attention";
})(GRAVITY || (GRAVITY = {}));
var urlBuilder = function (_a, imageUrl, opt) {
    var caravaggioUrl = _a.url, baseUrl = _a.baseUrl;
    var options = Object.entries(opt)
        .map(function (_a) {
        var operation = _a[0], value = _a[1];
        if (typeof value !== 'object') {
            return operation + ":" + value;
        }
        var valueString = Object.entries(value)
            .map(function (_a) {
            var k = _a[0], v = _a[1];
            return k + ":" + v;
        })
            .join(',');
        return operation + "," + valueString;
    })
        .join('/');
    var finalImageUrl = /^\.?\//.test(imageUrl) && baseUrl ? "" + baseUrl + imageUrl : imageUrl;
    return caravaggioUrl + "/" + options + "?image=" + encodeURIComponent(finalImageUrl);
};

var useCaravaggioImage = function (imageUrl, opt) {
    var context = useCaravaggio();
    return urlBuilder(context, imageUrl, opt);
};

var Image = function (_a) {
    var opt = _a.opt, src = _a.src, otherProps = __rest(_a, ["opt", "src"]);
    var url = useCaravaggioImage(src, opt);
    return React.createElement("img", __assign({ src: url }, otherProps));
};
var Image$1 = React.memo(Image);

var ImageSet = function (_a) {
    var sets = _a.sets, otherProps = __rest(_a, ["sets"]);
    var context = useCaravaggio();
    var sources = sets.map(function (set, i) {
        var srcSet = Object.entries(set.rules)
            .map(function (_a) {
            var rule = _a[0], _b = _a[1], opt = _b.opt, url = _b.url;
            return urlBuilder(context, url || otherProps.src, opt) + " " + rule;
        })
            .join(',');
        return (React.createElement("source", { type: set.type, srcSet: srcSet, key: otherProps.src + "-set-" + i }));
    });
    return (React.createElement("picture", null,
        sources,
        React.createElement("img", __assign({}, otherProps))));
};

export { CaravaggioProvider, Image$1 as Image, ImageSet, useCaravaggioImage };
